/* THIS IS A GENERATED FILE. DO NOT CHANGE IT. */
export const spacing_base = "8px";
export const spacing_01 = "2px";
export const spacing_02 = "4px";
export const spacing_03 = "8px";
export const spacing_04 = "12px";
export const spacing_05 = "16px";
export const spacing_06 = "24px";
export const spacing_07 = "32px";
export const spacing_08 = "40px";
export const spacing_09 = "48px";
export const spacing_10 = "64px";
export const spacing_11 = "80px";
export const spacing_12 = "96px";
export const spacing_13 = "160px";
export const base_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const mono_font_family = "Roboto Mono, ui-monospace, SF Mono, menlo, consolas, monospace";
export const base_font_size = "14px";
export const base_font_weight_regular = "400";
export const font_weight_medium = "500";
export const font_weight_semibold = "600";
export const base_line_height = "1.4286";
export const type_body_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_body_font_size = "0.875rem";
export const type_body_font_weight = "400";
export const type_body_line_height = "1.4286";
export const type_body_letter_spacing = "normal";
export const type_body_text_transform = "none";
export const type_emphasis_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_emphasis_font_size = "0.875rem";
export const type_emphasis_font_weight = "500";
export const type_emphasis_line_height = "1.4286";
export const type_emphasis_letter_spacing = "normal";
export const type_emphasis_text_transform = "none";
export const type_body_sm_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_body_sm_font_size = "0.8125rem";
export const type_body_sm_font_weight = "400";
export const type_body_sm_line_height = "1.4";
export const type_body_sm_letter_spacing = "normal";
export const type_body_sm_text_transform = "none";
export const type_body_xs_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_body_xs_font_size = "0.75rem";
export const type_body_xs_font_weight = "400";
export const type_body_xs_line_height = "1.4";
export const type_body_xs_letter_spacing = "normal";
export const type_body_xs_text_transform = "none";
export const type_caption_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_caption_font_size = "0.75rem";
export const type_caption_font_weight = "400";
export const type_caption_line_height = "1.35";
export const type_caption_letter_spacing = "normal";
export const type_caption_text_transform = "none";
export const type_micro_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_micro_font_size = "0.6875rem";
export const type_micro_font_weight = "400";
export const type_micro_line_height = "1.3";
export const type_micro_letter_spacing = "normal";
export const type_micro_text_transform = "none";
export const type_label_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_label_font_size = "0.8125rem";
export const type_label_font_weight = "600";
export const type_label_line_height = "1.35";
export const type_label_letter_spacing = "normal";
export const type_label_text_transform = "none";
export const type_overline_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_overline_font_size = "0.6875rem";
export const type_overline_font_weight = "600";
export const type_overline_line_height = "1.4";
export const type_overline_letter_spacing = "0.06em";
export const type_overline_text_transform = "uppercase";
export const type_code_font_family = "Roboto Mono, ui-monospace, SF Mono, menlo, consolas, monospace";
export const type_code_font_size = "0.875rem";
export const type_code_font_weight = "500";
export const type_code_line_height = "1.4";
export const type_code_letter_spacing = "normal";
export const type_code_text_transform = "none";
export const type_code_sm_font_family = "Roboto Mono, ui-monospace, SF Mono, menlo, consolas, monospace";
export const type_code_sm_font_size = "0.75rem";
export const type_code_sm_font_weight = "400";
export const type_code_sm_line_height = "1.35";
export const type_code_sm_letter_spacing = "normal";
export const type_code_sm_text_transform = "none";
export const type_display_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_display_font_size = "1.25rem";
export const type_display_font_weight = "600";
export const type_display_line_height = "1.2";
export const type_display_letter_spacing = "-0.01em";
export const type_display_text_transform = "none";
export const type_title_page_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_title_page_font_size = "1rem";
export const type_title_page_font_weight = "600";
export const type_title_page_line_height = "1.3";
export const type_title_page_letter_spacing = "-0.01em";
export const type_title_page_text_transform = "none";
export const type_title_card_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_title_card_font_size = "0.9375rem";
export const type_title_card_font_weight = "600";
export const type_title_card_line_height = "1.3";
export const type_title_card_letter_spacing = "-0.01em";
export const type_title_card_text_transform = "none";
export const type_title_section_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_title_section_font_size = "0.875rem";
export const type_title_section_font_weight = "600";
export const type_title_section_line_height = "1.35";
export const type_title_section_letter_spacing = "-0.005em";
export const type_title_section_text_transform = "none";
export const type_title_subsection_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_title_subsection_font_size = "0.8125rem";
export const type_title_subsection_font_weight = "600";
export const type_title_subsection_line_height = "1.35";
export const type_title_subsection_letter_spacing = "normal";
export const type_title_subsection_text_transform = "none";
export const type_button_font_family = "roboto, -apple-system, blinkmacsystemfont, helvetica neue, ubuntu, lucida grande, helvetica, arial, sans-serif";
export const type_button_font_size = "0.8125rem";
export const type_button_font_weight = "500";
export const type_button_line_height = "1";
export const type_button_letter_spacing = "0";
export const type_button_text_transform = "none";
export const overline_letter_spacing_wide = "0.08em";
export const text_primary = "#13131c";
export const text_medium = "#65666e";
export const text_disabled = "#909197";
export const text_link = "#5b4ecd";
export const text_inverse = "#fff";
export const text_on_fill = "#13131c";
export const text_highlight = "#f4f39f";
export const min_screen_width = "1000px";
export const full_nav_min_width = "1400px";
export const common_sidebar_width = "300px";
export const common_sidebar_collapsed_width = "100px";
export const header_height = "45px";
export const input_base_margin = "4px 0 8px 0";
export const dark_background_color = "#13131c";
export const dialog_width_xs = "360px";
export const dialog_width_sm = "540px";
export const dialog_width_md = "720px";
export const dialog_width_lg = "1080px";
export const box_shadow_small = "0 2px 4px #13131c1a";
export const box_shadow_medium = "0 10px 20px #13131c1a";
export const box_shadow_large = "0 20px 20px #13131c1a";
export const border_subtle = "#d0d0d5";
export const border_strong = "#909197";
export const border_interactive = "#8585df";
export const border_inverse = "#13131c";
export const border_disabled = "#adaeb4";
export const border_radius_none = "0";
export const border_radius_small = "4px";
export const border_radius_medium = "8px";
export const border_radius_large = "12px";
export const border_radius_pill = "9999px";
export const component_height_small = "28px";
export const component_height_medium = "32px";
export const component_height_large = "36px";
export const interactive = "#2f1c81";
export const interactive_text = "#5b4ecd";
export const interactive_hover = "#493ab1";
export const interactive_active = "#5b4ecd";
export const interactive_muted = "#8585df";
export const interactive_subtle = "#cbceee";
export const interactive_selected = "#493ab1";
export const surface_canvas = "#ededf0";
export const surface = "#fff";
export const surface_subtle = "#f6f6f8";
export const surface_band = "#f6f6f8";
export const surface_hover = "#ededf0";
export const surface_raised = "#d0d0d5";
export const surface_selected = "#e2e4f9";
export const surface_selected_hover = "#dadcf8";
export const surface_inverse = "#373842";
export const surface_disabled = "#f6f6f8";
export const surface_track = "#adaeb4";
export const surface_thumb = "#fff";
export const feedback_danger = "#b72722";
export const feedback_danger_fill = "#b72722";
export const feedback_danger_text = "#b72722";
export const feedback_danger_active = "#971c15";
export const feedback_warning_fill = "#d07801";
export const feedback_warning_text = "#9d4d00";
export const feedback_success_fill = "#029149";
export const feedback_success_text = "#027b3f";
export const feedback_info = "#5b4ecd";
export const feedback_warning = "#d07801";
export const feedback_success = "#029149";
export const feedback_danger_subtle = "#fcf4f3";
export const feedback_warning_subtle = "#fcf5ec";
export const feedback_success_subtle = "#f0f9f1";
export const feedback_info_subtle = "#f5f6fb";
export const feedback_info_inverse = "#a5a8e6";
export const feedback_warning_inverse = "#f79300";
export const feedback_danger_inverse = "#ea938d";
export const analysis_fail = "#b72722";
export const analysis_fail_text = "#b72722";
export const analysis_warn_fill = "#d07801";
export const analysis_warn_text = "#9d4d00";
export const analysis_pass_fill = "#029149";
export const analysis_pass_text = "#027b3f";
export const analysis_none = "#65666e";
export const analysis_warn = "#d07801";
export const analysis_pass = "#029149";
export const analysis_fail_subtle = "#fae9e7";
export const analysis_warn_subtle = "#fbead7";
export const analysis_pass_subtle = "#e1f3e3";
export const analysis_none_subtle = "#ededf0";
export const severity_critical = "#ea938d";
export const severity_critical_text = "#13131c";
export const severity_critical_border = "#971c15";
export const severity_high = "#f0c4c0";
export const severity_high_text = "#13131c";
export const severity_high_border = "#b72722";
export const severity_medium = "#fae9e7";
export const severity_medium_text = "#b72722";
export const severity_medium_border = "#d13934";
export const severity_low = "transparent";
export const severity_low_text = "#b72722";
export const severity_low_border = "#eb6c63";
export const dataviz_series_1 = "#555de3";
export const dataviz_series_2 = "#0093bf";
export const dataviz_series_3 = "#008c8b";
export const dataviz_series_4 = "#b654b0";
export const dataviz_series_5 = "#1351a6";
export const dataviz_series_6 = "#ae8ae1";
export const dataviz_series_strong = "#231167";
export const dataviz_neutral = "#55565e";
export const dataviz_track = "#adaeb4";
export const dataviz_grid = "#d0d0d5";
export const nitro_gradient_start = "#f6143f";
export const nitro_gradient_end = "#8a70ee";
export const nitro_gradient_flip = "#231167";
export const nitro = "linear-gradient(to right, #f6143f, #8a70ee)";
export const celebration_glow = "#e831ce80";
export const surface_brand = "#231167";
export const highlight_on_brand = "#493ab1";
export const text_on_brand = "#fff";
export const icon_size_xs = "16px";
export const icon_size_sm = "20px";
export const icon_size_md = "24px";
export const icon_size_lg = "32px";
export const popper_background = "#37384299";
export const data_visualization_green = "#197473";
export const required_field_asterisk = "#b72722";
//# sourceMappingURL=variables.js.map